import React from 'react'
import {Button, Card, CardBody} from 'reactstrap'
import makeImageLabels from '../helpers/makeImageLabels'
import ListItemsTable from './ListItemsTable'
import apiBarcode, {getExportOrdersCSV, getExportShippingOrdersCSV} from '../../services/api/apiBarcode'
import Loading from '../../components/Loading/Loading'
import ListItemsFooter from './ListItemsFooter'
import ListItemsFilter from './ListItemsFilter'
import ListItemsOverview from './ListItemsOverview'
import ModalEditItem from './ModalEditItem'
import printImage from '../helpers/printImage'
import {parse} from 'json2csv'
import {saveAs} from 'file-saver'
import compareSize from '../helpers/compareSize'
import ModalEditProduct from './ModalEditProduct'
import parseGGDriver from '../helpers/parseGGDriver'
import queryString from 'query-string'

class ListItemsPage extends React.Component {
    constructor(props) {
        super(props)

        const {location} = props.history

        let params = {}
        if (location.search !== '') {
            params = queryString.parse(location.search)
            params.production_status = 'not_canceled_not_onhold_not_packaged'
        }

        this.state = {
            items: [],
            isLoading: true,
            loading: false,
            loadingExport: false,
            error: '',
            pagination: {
                limit: 500,
                total: 0
            },
            filter: {
                hide_archived: 'hide_archived',
                production_status: 'not_canceled_not_onhold_not_packaged',
                created: {},
                barcodeNumber: {},
                ...params
            },
            itemEdit: null,
            productEdit: null,
            prev: null,
            next: null
        }
    }

    componentDidMount() {
        this._fetchItems()
    }

    componentWillUnmount() {
        this.timeoutFilter = null
    }

    timeoutFilter = null

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.pagination.page !== prevState.pagination.page) {
            this._fetchItems()
        }

        if (this.state.pagination.limit !== prevState.pagination.limit) {
            this._fetchItems()
        }

        if (Object.keys(this.state.filter).length !== Object.keys(prevState.filter).length || this.state.filter['barcodeNumber[$gte]'] !== prevState.filter['barcodeNumber[$gte]'] ||
            this.state.filter['barcodeNumber[$lte]'] !== prevState.filter['barcodeNumber[$lte]'] ||
            this.state.filter.search !== prevState.filter.search || this.state.filter['shipped_at[$gte]'] !== prevState.filter['shipped_at[$gte]'] ||
            this.state.filter['shipped_at[$lte]'] !== prevState.filter['shipped_at[$lte]'] ||
            this.state.filter.search !== prevState.filter.search) {
            if (this.timeoutFilter) clearTimeout(this.timeoutFilter)
            this.timeoutFilter = setTimeout(this._fetchItems, 350)
        } else {
            for (let key of Object.keys(this.state.filter)) {
                if (this.state.filter[key] !== prevState.filter[key]) {
                    if (this.timeoutFilter) clearTimeout(this.timeoutFilter)
                    this.timeoutFilter = setTimeout(this._fetchItems, 350)
                    break
                }
            }
        }

        if (this.state.filter !== prevState.filter) {
            if (this.timeoutFilter) clearTimeout(this.timeoutFilter)
            this.timeoutFilter = setTimeout(this._fetchItems, 350)
        }

        if (prevProps.history.location.search !== this.props.history.location.search) {
            const {history} = this.props
            const {location} = history

            if (location.search !== '') {
                const params = queryString.parse(location.search)
                params.production_status = 'not_canceled_not_onhold_not_packaged'

                this.setState((oldState) => {
                    return {
                        ...oldState,
                        ...params,
                    }
                })
            }

        }
    }

    _handleChangeFilter = (filter) => {
        this.setState({filter})
    }

    _fetchItems = async () => {
        this.setState({
            loading: true
        })

        try {
            const {pagination, filter} = this.state
            const cloneFilter = Object.assign({}, filter)
            const newOvertime = filter['products.overtime']

            if (!cloneFilter.created.hasOwnProperty('from') && !cloneFilter.created.hasOwnProperty('to')) {
                delete cloneFilter['created']
            }

            if (!cloneFilter.barcodeNumber.hasOwnProperty('$gte') && !cloneFilter.barcodeNumber.hasOwnProperty('$lte')) {
                delete cloneFilter['barcodeNumber']
            }

            const overtime = {}

            if (filter.hasOwnProperty('products.overtime[$lte]')) {
                Object.assign(overtime, {$lte: filter['products.overtime[$lte]']})
                delete cloneFilter['products.overtime[$lte]']
            }

            if (filter.hasOwnProperty('products.overtime[$gt]')) {
                Object.assign(overtime, {$gt: filter['products.overtime[$gt]']})
                delete cloneFilter['products.overtime[$gt]']
            }

            Object.assign(cloneFilter, {'products.overtime': overtime})

            if (!cloneFilter['products.overtime'].hasOwnProperty('$gt') && !cloneFilter['products.overtime'].hasOwnProperty('$gte')) {
                cloneFilter['products.overtime'] = newOvertime
            }

            const {page, limit} = pagination
            const resRead = await apiBarcode.getListBarcode({page, limit, ...cloneFilter})
            const {success, barcodes, message, total, prev, next} = resRead.data

            if (!success) throw new Error(message)

            this.setState({
                items: barcodes,
                pagination: {...pagination, total},
                error: '',
                isLoading: false,
                loading: false,
                prev: prev,
                next: next
            })
        } catch (e) {
            alert(e.message)

            this.setState({
                error: '',
                isLoading: false,
                loading: false,
                prev: null,
                next: null
            })
        }
    }

    _reloadItems = () => {
        return this._fetchItems()
    }

    _handleChangePage = (pagi) => {
        const {pagination} = this.state
        this.setState({
            pagination: {...pagination, ...pagi}
        })
    }

    _parseDate = (dateString) => {
        const parts = dateString.split('/')
        return new Date(parts[2], parts[1] - 1, parts[0])
    }

    _parseTrackings = (items) => {

        return items.map(item => {
            const {orderNumber, products} = item
            const trackings = products.filter(product => {
                return product.hasOwnProperty('labelDetails')
            })
            let partnerTrackingNumber = ''
            if (trackings.length > 0) {
                const partnerTrackingNumbers = trackings.map(tracking => {
                    return tracking.labelDetails.partnerTrackingNumber
                })
                partnerTrackingNumber = partnerTrackingNumbers.join()
                return {orderNumber, tracking: partnerTrackingNumber}
            } else if (item.hasOwnProperty('labelDetails')) {
                if (item.labelDetails !== null && item.labelDetails.hasOwnProperty('partnerTrackingNumber')) {
                    partnerTrackingNumber = item.labelDetails.partnerTrackingNumber
                    return {orderNumber, tracking: partnerTrackingNumber}
                }
            }

            return {orderNumber, tracking: ''}
        }).reverse()
    }

    _handleCopyTracking = () => {
        const {items} = this.state
        const tracking = this._parseTrackings(items)

        const fields = ['orderNumber', 'tracking']
        const opts = {fields}

        try {
            const csv = parse(tracking, opts)
            const file = new File([csv], 'tracking.csv', {type: 'application/csv; charset=UTF-8'})
            saveAs(file)
        } catch (err) {
            alert(err.message)
        }
    }

    _parseLabels = (items) => {
        const results = []
        const nww = ['US', 'VN']
        const usex = ['PR', 'AE', 'AP', 'AO', 'VI', 'AA']

        for (let item of items) {
            const {barcodeNumber, country, state, production_status} = item

            let {products} = item

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            // prevent print qr on-hold, cancelled orders
            if (!['on-hold', 'cancelled'].includes(production_status)) {
                for (let i in products) {
                    const product = products[i]
                    const {color, size, designFront, designBack} = product
                    const pos = product.hasOwnProperty('pos') ? product.pos : (parseInt(i) + 1)
                    const side = `${designFront ? 'F' : ''}${designBack ? 'B' : ''}`
                    const type = product.type
                    // const type_code = whl[product.type.toUpperCase()]['SHORT_CODE'];
                    // console.log()
                    let loc = ''

                    if ((nww.indexOf(country.toUpperCase()) === -1) || (country.toUpperCase() === 'US' && usex.indexOf(state.toUpperCase()) !== -1)) {
                        loc = "WW"
                    } else {
                        loc = country.toUpperCase()
                    }
                    const label = {
                        orderId: `${barcodeNumber}_${pos}`,
                        // total: products.length,
                        total: item.items.length,
                        pos: pos,
                        posColor: item.items.length > 1 ? 'white' : 'black',
                        posBackground: item.items.length > 1 ? 'black' : 'white',
                        color: color,
                        size: size,
                        side: side,
                        sideBackground: side === 'FB' ? 'black' : 'white',
                        type: type,
                        // code: type_code,
                        loc: loc
                    }
                    results.push(label)
                }
            }
        }

        const sortedLabels = [...results].sort((a, b) => {

            if (a.color > b.color) return 1
            if (a.color < b.color) return -1

            const cpSize = compareSize(a.size, b.size)
            if (cpSize) return cpSize

            if (a.side > b.side) return 1
            if (a.side < b.side) return -1
            if (a.orderId > b.orderId) return 1
            if (a.orderId < b.orderId) return -1
            if (a.orderId > b.orderId) return -1
            if (a.orderId < b.orderId) return 1

            return 0
        })

        return sortedLabels
    }

    _handlePrintLabels = async () => {
        try {
            const {items} = this.state
            const labels = this._parseLabels(items)
            const image = await makeImageLabels(labels)

            printImage(image)
        } catch (e) {
            alert(e.message)
        }
    }

    _parseARX4 = (items) => {
        const results = []

        for (let item of items) {
            const {barcodeNumber, products} = item

            for (let i in products) {
                const product = products[i]
                const {color, size, designFront, designBack} = product

                if (designFront) {
                    results.push({
                        color,
                        size,
                        name: `${barcodeNumber}_${parseInt(i) + 1}_F`,
                        design: parseGGDriver(designFront)
                    })
                }
                if (designBack) {
                    results.push({
                        color,
                        size,
                        name: `${barcodeNumber}_${parseInt(i) + 1}_B`,
                        design: parseGGDriver(designBack)
                    })
                }
            }
        }

        return results
    }

    _handleClickARX4 = () => {
        const {items} = this.state
        const arx4 = this._parseARX4(items)

        const fields = ['name', 'color', 'size', 'design']
        const opts = {fields}

        try {
            const csv = parse(arx4, opts)
            const file = new File([csv], 'arx4.csv', {type: 'application/csv; charset=UTF-8'})
            saveAs(file)
        } catch (err) {
            alert(err.message)
        }
    }

    _exportShipping = async () => {
        const {filter} = this.state

        this.setState({
            loadingExport: true
        })

        try {
            const cloneFilter = Object.assign({}, filter)

            delete cloneFilter['created']

            if (filter.created.hasOwnProperty('from')) {
                cloneFilter['created[$gte]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilter['created[$lte]'] = filter.created.to
            }

            delete cloneFilter['barcodeNumber']

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilter['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilter['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            window.location.href = getExportShippingOrdersCSV({...cloneFilter})

            this.setState({
                loadingExport: false
            })
        } catch (err) {
            alert(err.message)
            this.setState({
                loadingExport: false
            })
        }
    }

    _openModalEdit = (item) => {
        this.setState({itemEdit: item})
    }

    _closeModalEdit = () => {
        this.setState({itemEdit: null})
    }

    _renderModalEdit = () => {
        const {itemEdit} = this.state
        if (itemEdit) return <ModalEditItem isOpen={!!itemEdit} item={itemEdit} toggle={this._closeModalEdit}
                                            reload={this._reloadItems}/>
    }

    _openModalEditProduct = (item) => {
        this.setState({productEdit: item})
    }

    _closeModalEditProduct = () => {
        this.setState({productEdit: null})
    }

    _renderModalEditProduct = () => {
        const {productEdit} = this.state
        if (productEdit) return <ModalEditProduct isOpen={!!productEdit} product={productEdit}
                                                  toggle={this._closeModalEditProduct}
                                                  reload={this._reloadItems}/>
    }

    _duplicateItem = async (itemId) => {
        const copyItem = (item) => {
            const {note, orderNumber, name, address1, address2, city, state, country, phone, postalCode, products, height, length, weight, width, items} = item

            const newProducts = products.map(product => {
                const {mockUpFront, mockUpBack, designFront, designBack, size, color, type, quantity} = product
                return {mockUpFront, mockUpBack, designFront, designBack, size, color, type, quantity}
            })

            return {
                note,
                orderNumber,
                name,
                address1,
                address2,
                city,
                state,
                country,
                phone,
                postalCode,
                products: newProducts,
                height,
                length,
                weight,
                width,
                items
            }
        }

        try {
            const {items} = this.state
            const item = items.find(_item => _item._id === itemId)

            if (!item) throw new Error('Item duplicate not found.')

            const newItem = copyItem(item)

            const resCreated = await apiBarcode.createListBarcode([newItem])
            const {success, message} = resCreated.data

            if (!success) throw new Error(message)

            await this._reloadItems()
        } catch (e) {
            alert(e.message)
        }
    }

    _exportOrders = async () => {
        const {pagination, filter} = this.state
        const {page, limit} = pagination

        try {
            const cloneFilterExp = Object.assign({}, filter)

            delete cloneFilterExp['created']
            delete cloneFilterExp['barcodeNumber']

            if (filter.created.hasOwnProperty('from')) {
                cloneFilterExp['created[from]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilterExp['created[to]'] = filter.created.to
            }

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilterExp['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilterExp['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            window.location.href = getExportOrdersCSV({paged: page, limit, ...cloneFilterExp})
        } catch (e) {
            alert(e.toString())
        }
    }

    render() {
        if (this.state.isLoading) return <Loading/>

        const {items, pagination, filter, loading, loadingExport, prev, next} = this.state

        return (
            <div className='ListItemsPage'>
                <Card>
                    <div className="card-header bg-success text-white header-elements-inline">
                        <h4 className='card-title'>
                            Quản trị in ấn
                        </h4>
                        <div className="header-elements">
                            <Button className="btn btn-warning btn-labeled btn-labeled-left"
                                    onClick={this._exportOrders}><b><i className="icon-barcode2"/></b>Export
                                Orders</Button>
                            <Button className="btn btn-warning btn-labeled btn-labeled-left ml-1"
                                    onClick={this._exportShipping}>
                                <b>{loadingExport ? <i className="fa fa-spinner fa-spin"/> :
                                    <i className="icon-barcode2"/>}</b>
                                Export Shipping
                            </Button>
                            <Button className="btn btn-primary btn-labeled btn-labeled-left ml-1"
                                    onClick={this._handleCopyTracking}><b><i className="icon-truck"/></b> Tải về DHL
                                Tracking</Button>
                            <Button className="btn btn-danger btn-labeled btn-labeled-left ml-1"
                                    onClick={this._handlePrintLabels}><b><i className="icon-qrcode"/></b> In mã
                                QR</Button>
                            <Button className="btn btn-light btn-labeled btn-labeled-left ml-1"
                                    onClick={this._handleClickARX4}><b><i className="icon-printer2"/></b> Tải
                                ARX4</Button>
                        </div>
                    </div>
                    <CardBody>
                        <ListItemsOverview items={items}/>
                        <ListItemsFilter filter={filter} onChangeFilter={this._handleChangeFilter}/>
                        <ListItemsTable
                            loading={loading}
                            items={items}
                            reloadItems={this._reloadItems}
                            openModalEdit={this._openModalEdit}
                            openModalEditProduct={this._openModalEditProduct}
                            duplicateItem={this._duplicateItem}
                        />
                        <ListItemsFooter
                            loading={loading}
                            prev={prev}
                            next={next}
                            pagination={pagination}
                            filter={filter}
                            onChangePagination={this._handleChangePage}
                            onChangeFilter={this._handleChangeFilter}
                        />
                    </CardBody>
                </Card>
                {this._renderModalEdit()}
                {this._renderModalEditProduct()}
            </div>
        )
    }
}

export default ListItemsPage
